module.exports = __webpack_public_path__ + "eb6383f8.png";